import { pushEvent } from '../../utils/gtmDataLayer';
import { AppPenetrationAction, AppPenetrationPage } from '../../models';

export type AppPenetrationTrackingAction = 'View' | 'Click' | 'Close';

/** GTM event per ActionPenetrationApp, so each action's reach and conversion can be measured. */
export function trackAppPenetration(
	trackingAction: AppPenetrationTrackingAction,
	action: AppPenetrationAction,
	page: AppPenetrationPage,
) {
	pushEvent({
		type: 'TrackingEvent',
		dataLabel: 'trackingEvent',
		data: {
			category: 'AppPenetration',
			action: trackingAction,
			label: `${page}:${action.id}`,
			actionPenetrationAppId: action.id,
			page,
		},
	});
}
